<script>
  export let onClick
  export let color = "#184398";
</script>

<button on:click={onClick}>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M4 6C4 4.89543 4.89543 4 6 4H9V6H6V18H18V15H20V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V6Z"
          fill="{color}"/>
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M13 4H18H20V6V11H18V7.42843L10.5485 14.88L9.13425 13.4658L16.6 6H13V4Z" fill="{color}"/>
  </svg>
</button>

<style>
  svg {
    vertical-align: middle;
  }
</style>
